import { createApp, h, ref } from "vue";
import Toast from "../components/toast.vue";
import type { App } from "vue";

export class Message {
  private readonly state = {
    visible: ref(false),
    loading: ref(false),
    message: ref(""),
    timer: -1,
    toast: null as App<Element> | null,
  };

  private initialize() {
    if (this.state.toast) return;

    this.state.toast = createApp({
      render: () => {
        return h(Toast, {
          "visible": this.state.visible.value,
          "loading": this.state.loading.value,
          "message": this.state.message.value,
          "onUpdate:visible": (value: boolean) => {
            this.state.visible.value = value;
          },
        });
      },
    });

    this.state.toast.mount(document.createElement("div"));
  }

  public info(options: { message: string; duration?: number }) {
    this.initialize();
    this.state.loading.value = false;
    this.state.message.value = options.message;
    this.state.visible.value = true;

    window.clearTimeout(this.state.timer);
    this.state.timer = window.setTimeout(() => {
      this.state.visible.value = false;
    }, options.duration ?? 3000);
  }

  public loading(visible: boolean) {
    this.initialize();
    this.state.message.value = "";
    this.state.visible.value = visible;

    if (visible) {
      window.clearTimeout(this.state.timer);
      this.state.loading.value = true;
      return;
    }

    window.clearTimeout(this.state.timer);
    window.setTimeout(() => {
      this.state.loading.value = false;
      this.state.message.value = "";
    }, 1000);
  }

  public install(app: App): void {
    Object.defineProperty(app.config.globalProperties, "$message", {
      enumerable: true,
      get: () => this,
    });
  }
}

export default new Message();
